module.exports = __webpack_public_path__ + "static/media/part-detail-slide-6.f0289b78.jpg";